import { apiResendEmail, apiCheckTenantStatus } from '../../apis/registration'
import { env } from '../../constants'

export function requestResendEmail(token) {
  return apiResendEmail.request(token)
}

export function requestCheckTenantStatus(token) {
  if (env.USE_MOCK) {
    // mock
    // 可以通过修改 status 进入不同场景
    return Promise.resolve({
      status: 2,
      tenant_active_url: 'tenant_active_url',
    })
  }

  return apiCheckTenantStatus.request(token)
}
